import React from 'react';
import { Navigate, Outlet } from 'react-router';

import { DevOnlyRoute } from '@/backoffice/app/dev-only-route/dev-only-route';
import { TCustomRouteObject } from '@/shared/types/router.types';

// DevOnlyRoute gates on its `children` prop, so nested routes need an
// Outlet inside it rather than passing it as the route Component directly.
const IdeaasGuard: React.FC = () => (
  <DevOnlyRoute>
    <Outlet />
  </DevOnlyRoute>
);

// No `permission` gate -- gated instead by the `custom:isDeveloper` Cognito
// attribute via DevOnlyRoute; real per-action RBAC is a fast-follow.
export const ideaasRoutes: TCustomRouteObject = {
  path: 'ideaas',
  Component: IdeaasGuard,
  handle: {
    crumb: {
      label: 'ideaas',
      localized: true,
    },
  },
  children: [
    {
      index: true,
      element: <Navigate to="configuration" replace />,
    },
    {
      lazy: async () => {
        const { IdeaasRoute } = await import('./ideaas');
        return { Component: IdeaasRoute };
      },
      children: [
        {
          path: 'configuration',
          lazy: async () => {
            const { ConfigurationRoute } = await import('./configuration');
            return { Component: ConfigurationRoute };
          },
        },
        {
          path: 'analytics',
          lazy: async () => {
            const { AnalyticsRoute } = await import('./analytics');
            return { Component: AnalyticsRoute };
          },
        },
      ],
    },
  ],
};
